import { Card, FloatButton, Pagination, Space } from 'antd'
import React from 'react'
import { useSelector } from 'react-redux'
import { useState } from 'react'
import { LeftOutlined } from '@ant-design/icons';
import MobileMailingsContent from './MobileMailingsContent'
import MobileMailingsInfo from './MobileMailingsInfo';

const MobileMailingsPage = ({
    mailingsContent,
    setMailingsContent,
    mailingsInfo,
    setMailingsInfo,
    visible,
    setVisible,
    mnemo
}) => {

    const mailingsContentList = useSelector(state => state.MailingsSlice.mailingsContentList)
    const mailingsContentListLoading = useSelector(state => state.MailingsSlice.mailingsContentListLoading)

    const mailingsInfoListActionList = useSelector(state => state.MailingsSlice.mailingsInfoList)
    const mailingsInfoListActionListLoading = useSelector(state => state.MailingsSlice.mailingsInfoListLoading)

    const [tab, setTab] = useState('Справочник рассылок')
    const [page, setPage] = useState(1)

    return (
        <Space style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} direction="vertical">

            <Pagination
                defaultCurrent={page}
                pageSize={20}
                showSizeChanger={false}
                current={page}
                onChange={(page, pageSize) => {
                    setPage(page)
                }}
                total={mailingsContentList?.value?.data?.totalCount}
                page={page}
            />

            {tab === 'Справочник рассылок' && <MobileMailingsContent
                mailingsContentList={mailingsContentList}
                mailingsContentListLoading={mailingsContentListLoading}
                setTab={setTab}
                mailingsContent={mailingsContent}
                setMailingsContent={setMailingsContent}
                mnemo={mnemo}
            />}
            {tab === 'Детали рассылки' && <MobileMailingsInfo
                mailingsInfoListActionList={mailingsInfoListActionList}
                mailingsInfoListActionListLoading={mailingsInfoListActionListLoading}
                mailingsInfo={mailingsInfo}
                mailingsContent={mailingsContent}
                setMailingsInfo={setMailingsInfo}
                setVisible={setVisible}
                mnemo={mnemo}
                setTab={setTab}
            />}
                 {(tab === 'Детали рассылки') &&
                <FloatButton
                    style={{ left: 24 }}
                    type="primary"
                    icon={<LeftOutlined />}
                    onClick={() => {
                        if (tab === 'Детали рассылки') {
                            setTab('Справочник рассылок')
                        }
                    }}
                />}
        </Space>
    )
}

export default MobileMailingsPage